import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Et3CustomizedButton from "../../core/et3-button/Et3CustomizedButton";
import ET3Div from "../../core/et3-div";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import ET3Circle from "../et3-circle";
import { backToTop } from "../../helpers/et3-back-top";
import getCoreHistoryStore from "../../stores/core/core-history-store";
import { BACK_TO_TOP_PAGES_ARRAY } from "../../constants/input-entries-constants";

const BackToTop = withLiteObserverAndTheme<{
  refDiv: React.RefObject<HTMLDivElement>;
}>((props) => {
  const { theme, refDiv } = props;
  const { colors, unitY, unitX } = theme;
  const pagesAllowBackToTop = BACK_TO_TOP_PAGES_ARRAY;
  const shouldShow = pagesAllowBackToTop.includes(
    getCoreHistoryStore().pageName.get()
  );

  return !shouldShow ? null : (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="row"
      justifyContent="center"
      alignItems="center"
      withShadow={false}
      width={60}
      height={60}
      color={colors.all.transparent}
      style={{ position: "fixed", right: 30 * unitY, bottom: 2 * unitY }}
      onClick={() => {}}
    >
      <ET3Circle
        size={50}
        color={colors.all.transparent}
        style={{
          justifyContent: "center",
          alignItems: "center"
        }}
        withShadow={false}
        onClick={() => {}}
      >
        <Et3CustomizedButton
          isEnabled={true}
          withShadow={false}
          width={65}
          height={65}
          fDirection="row"
          alignItems="center"
          justifyContent="center"
          color={colors.all.bondiBlue}
          style={{}}
          onClick={() => backToTop(refDiv)}
        >
          <FontAwesomeIcon
            icon={faArrowUp}
            style={{
              fontSize: 30 * unitX,
              color: colors.all.white
            }}
          />
        </Et3CustomizedButton>
      </ET3Circle>
    </ET3Div>
  );
});
export default BackToTop;
